import React from "react";
import { useSelector } from "react-redux";
import Message from "./Message";
import classes from "./Messages.module.css";


const Messages = () => {

    const texts = useSelector(state => state.translate.texts);
    const messages = useSelector(state => state.messages.messages);

    return (
        <div className={classes.Messages}>
            {messages && messages.length > 0 ? messages.map((m, i) =>
                <Message key={i} message={m} />
            ) :
                <div className={classes.NoMessages}>{texts.noMessages}</div>}
        </div>
    )
}
export default Messages